import { getKsdmConfig } from 'helpers/index';

/**
 * footer#ksdm-footer — AHU board variant (templates/common/ahuBase.html):
 * `.col-xs-12 > .row > .col-xs-12.footer-wrapper.bottom-5` wrapping the shared
 * common/footer.html content (copyright + software/master/CMS versions from
 * the server-injected config — same data PageFooter consumes, different
 * wrapper classes, hence a local component instead of prop-bending PageFooter).
 */
const AhuBoardFooter = () => {
  const cfg = getKsdmConfig();
  const year = cfg?.year ?? new Date().getFullYear();
  const software = cfg?.versions?.software;
  const master = cfg?.versions?.master;
  const cmsVersion = cfg?.versions?.cms;

  return (
    <footer id="ksdm-footer">
      <div className="col-xs-12">
        <div className="row">
          <div className="col-xs-12 footer-wrapper bottom-5">
            <div className="text-right">
              <small id="ksdm-copyright" className="right mt-0">
                Powered by Kinetix Air | &#169; {year} Kinetix Software LLC | All Rights
                Reserved
              </small>
            </div>
            {software && (
              <div className="">
                <small id="ksdm-dbs-version" className="mt-0">
                  <span className="ka-has-tooltip" tooltip="Software version">
                    {software}
                  </span>{' '}
                  |{' '}
                  <span className="ka-has-tooltip" tooltip="Master DB version">
                    {master}
                  </span>
                  {cmsVersion && (
                    <>
                      {' '}
                      |{' '}
                      <span className="ka-has-tooltip cms_version" tooltip="CMS DB version">
                        {cmsVersion}
                      </span>
                    </>
                  )}
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AhuBoardFooter;
